import React from 'react';
import { Box, Skeleton } from '@mui/material';

type Props = {
    height?: number;
};

// グラフの読み込み中プレースホルダ。Y 軸風の縦バー＋プロット領域の矩形＋X 軸風の横バーで
// チャートの枠を想起させる。loading 中の見た目のみで、系列定義・データ取得は不変。
export const ChartSkeleton: React.FC<Props> = ({ height = 240 }) => (
    <Box sx={{ width: '100%', p: 1, display: 'flex', gap: 1 }} aria-busy="true" aria-live="polite">
        <Skeleton variant="rounded" width={8} height={height} />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Skeleton variant="rounded" height={height} sx={{ width: '100%' }} />
            <Skeleton variant="rounded" height={8} sx={{ width: '100%' }} />
        </Box>
    </Box>
);
